<app-happy-day-motif></app-happy-day-motif>
<div class="container">
  <div id="content">
    <div>
      <h1 style="color: #429C8C; text-align: center;">The Child Safety Portal has been replaced by Unify and is no longer available</h1>
    </div>
    <img src="/assets/img/logos/unify-icon.png" alt="Unify Logo" class="unify-logo" style="width: 100px; display: block; margin: 0 auto;">
  </div>
</div>

<ng-template #filterContainer></ng-template>